// extracted by mini-css-extract-plugin
export default {"home":"Navbar_home__J9qLd","inactive":"Navbar_inactive__QJPar","active":"Navbar_active__09bEE","burger":"Navbar_burger__w6+IB"};